import React from 'react';
import withLocalizeAwareIframe from 'pages/utils/withLocalizeAwareIframe';
import withRouteAwareIframe from 'pages/utils/withRouteAwareIframe';
import withValidSessionIframe from 'pages/utils/withValidSessionIframe';
import useIframePostMessage, { Message } from 'hooks/useIframePostMessage';

const SalesLedgerIframe: React.FC = () => {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  const [message, setMessage] = React.useState<Message>(null);
  const { iframeRef } = useIframePostMessage({ message });

  React.useEffect(() => {
    const buildMessage = async () => {
      const isPrimaryUser = await window.lsCloud.Config.access('is_primary_user');
      const modulesList: ModuleName[] = [
        'settings.employees.limit_to_multiple_shops',
        'register.sales.tip',
      ];
      const modules = modulesList.filter(module => window.lsCloud.Modules.hasModule(module));
      setMessage({
        type: 'retailEmployee',
        payload: { isPrimaryUser, modules },
      });
    };
    buildMessage();
  }, []);

  return (
    <>
      <style
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `.react-page { height: 100% }`,
        }}
      />
      <iframe
        title="inventory suppliers"
        src={`/webapps_redirect.php?app=retail-reports&next=${encodeURIComponent(
          `/sales${window.location.search}`
        )}`}
        style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
        ref={iframeRef}
      />
    </>
  );
};

export default withLocalizeAwareIframe(
  withRouteAwareIframe(withValidSessionIframe(SalesLedgerIframe))
);
